import { Component } from '@angular/core'

@Component({
  selector: 'lin-layout-form-toolbar-info',
  template: ` <ng-content></ng-content> `,
  styleUrls: ['./form-toolbar-info.component.scss'],
  standalone: false,
})
export class FormToolbarInfoComponent {}

@Component({
  selector: 'lin-layout-form-toolbar-info-row',
  template: ` <ng-content></ng-content> `,
  styles: [
    `
      :host {
        margin-bottom: 4px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }
    `,
  ],
  standalone: false,
})
export class FormToolbarInfoRowComponent {}

@Component({
  selector: 'lin-layout-form-toolbar-info-label',
  template: ` <ng-content></ng-content> `,
  styles: [
    `
      :host {
        min-width: 85px;
        font-weight: 900;
        text-align: right;
        margin-right: 5px;
      }
    `,
  ],
  standalone: false,
})
export class FormToolbarInfoLabelComponent {}

@Component({
  selector: 'lin-layout-form-toolbar-info-value',
  template: ` <ng-content></ng-content> `,
  styles: [
    `
      :host {
        min-width: 125px;
      }
    `,
  ],
  standalone: false,
})
export class FormToolbarInfoValueComponent {}
